import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators , compose} from "redux";
import { withSnackbar } from 'notistack';
import {removeNotification} from '@componentDP/js_react/redux/actions/application';
import {withStyles} from "@material-ui/core";
import Close from '@material-ui/icons/Close';

const styles = theme => ({
    cursorPointer: {
        cursor: 'pointer',
    }
});

class Notifier extends React.Component {
    constructor(props) {
        super(props);
        this.action = this.action.bind(this);
        this.state = {
            displayed: [],
        }
    }
    action = key => {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div className={classes.cursorPointer} onClick={() => { this.props.closeSnackbar(key) }}>
                    <Close />
                </div>
            </React.Fragment>
        )
    };
    render() {
        const { notificationsApplication } = this.props;
        const {action} = this;
        notificationsApplication.notifications.map(notification => {
            setTimeout(() => {
                if (this.state.displayed.filter(key => key === notification.key).length > 0) {
                    return;
                }
                this.props.enqueueSnackbar(
                    <div dangerouslySetInnerHTML={{ __html: notification.message }} />,
                    {variant: notification.type, anchorOrigin: {vertical: 'top', horizontal: 'right'}, action});
                this.setState({displayed: [...this.state.displayed, notification.key]});
                this.props.removeNotification(notification.key);
            }, 300);
        });
        return null;
    }
}

function mapStateToProps(state) {
    return {
        notificationsApplication: state.notificationsApplication,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        removeNotification,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withSnackbar(Notifier));
